document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-sd-mobile-toggle]');
  if (!toggle) return;

  e.preventDefault();

  const panel = document.querySelector('.sd-mobile-cat__panel');
  if (!panel) return;

  panel.classList.add('is-open');
  document.body.classList.add('sd-mobile-lock');
});
